module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    model: {
      value: (_vm.$store.state.gen.showSnack),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.gen, "showSnack", $$v)
      },
      expression: "$store.state.gen.showSnack"
    }
  }, [_c('div', [_c('div', [_vm._v("\n        " + _vm._s(_vm.line1) + "\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(_vm.line2) + "\n      ")])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "pink",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.$store.state.gen.showSnack = false
      }
    }
  }, [_vm._v("\n      Close\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e89246c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/snackbar_alert.vue
// module id = 525
// module chunks = 17